import { objectToCamelCase, objectToSnakeCase } from '../utils'
import api from './api'

export default class FAQ {
  static api = api.create(FAQ)
  static readOnlyFields = ['id']
  constructor(faq) {
    const {
      id = '',
      question = '',
      answerHtml = '',
      organization = '',
      order = null,
      answer = null,
      faqOrder = null,
    } = faq
    Object.assign(this, {
      id,
      question,
      answerHtml,
      organization,
      order,
      answer,
      faqOrder,
    })
  }

  static create(opts) {
    return new FAQ(opts)
  }

  static fromAPI(json) {
    return new FAQ(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(actions, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = actions[field]
      })
    } else {
      data = FAQ
    }

    //
    excludeFields = [...FAQ.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
  static checkIsInstance(obj, name) {
    if (!(obj instanceof FAQ)) {
      throw Error(`${name} must be an instance of the FAQ class.`)
    }
  }
}
